<app-auth-card
  [loader]="loader"
  [title]="'auth.companyLogin.title' | translate"
  [description]="'auth.companyLogin.description' | translate"
>
  <form [formGroup]="editForm" (ngSubmit)="onSubmit()" class="grid grid-cols-1 gap-4">
    <div>
      <label
        [appRequiredLabel]="editForm.controls.badgeCode"
        for="badgeCode"
        class="block text-surface-900 dark:text-surface-0 text-xl font-medium mb-2"
        >{{ 'auth.companyLogin.badgeCode' | translate }}</label
      >
      <input
        #badgeCodeInput
        pInputText
        id="badgeCode"
        type="password"
        class="w-full"
        formControlName="badgeCode"
        autocomplete="off"
        autocapitalize="off"
        spellcheck="false"
        [placeholder]="'auth.companyLogin.badgeCodePlaceholder' | translate"
        aria-describedby="badgeCodeHint"
      />
      <small id="badgeCodeHint" class="block text-muted-color mt-1">
        {{ 'auth.companyLogin.badgeCodeHint' | translate }}
      </small>
      <app-form-error [control]="editForm.controls.badgeCode" />
    </div>

    @if (isCameraActive()) {
      <div class="rounded-xl overflow-hidden bg-black aspect-video">
        <video
          #cameraVideo
          class="w-full h-full object-cover"
          muted
          playsinline
          [attr.aria-label]="'auth.companyLogin.cameraPreview' | translate"
        ></video>
      </div>
      <p class="text-center text-muted-color m-0" role="status">
        {{ 'auth.companyLogin.cameraScanning' | translate }}
      </p>
    }

    <p-button
      type="submit"
      [label]="'auth.companyLogin.submit' | translate"
      icon="pi pi-sign-in"
      size="large"
      styleClass="w-full"
    />

    @if (isCameraSupported) {
      <p-button
        type="button"
        [label]="(isCameraActive() ? 'auth.companyLogin.stopCamera' : 'auth.companyLogin.scanWithCamera') | translate"
        [icon]="isCameraActive() ? 'pi pi-times' : 'pi pi-camera'"
        [outlined]="true"
        size="large"
        styleClass="w-full"
        (onClick)="onToggleCamera()"
      />
    }
  </form>

  <div class="mt-6 text-center">
    <a [routerLink]="['/auth/login']" class="text-primary font-medium no-underline hover:underline">
      {{ 'auth.companyLogin.useEmailAndPassword' | translate }}
    </a>
  </div>
</app-auth-card>
